import { OmnivorePosType } from './omnivore_pos_type.js';

export function name(posType: OmnivorePosType): string {
  switch (posType) {
    case OmnivorePosType.Test:
      return 'Test POS';
    case OmnivorePosType.Micros3700:
      return 'Micros 3700';
    case OmnivorePosType.Simphony1:
      return 'Micros Simphony 1 (FE)';
    case OmnivorePosType.Simphony18_2:
      return 'Micros Simphony 18.2';
    case OmnivorePosType.Simphony2:
      return 'Micros Simphony 2';
    case OmnivorePosType.NcrAloha:
      return 'NCR Aloha';
    case OmnivorePosType.ParBrink:
      return 'PAR Brink';
    case OmnivorePosType.Positouch:
      return 'Positouch';
  }
}
